import styled from 'styled-components';

export const StyledLinkContent = styled.span`
  position: relative;
`;
